import { motion } from 'framer-motion';

const AboutIntro = () => {
  return (
    <section className="pt-32 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left - Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-3"
          >
            <p className="text-sm uppercase tracking-wider text-gray-500 mb-3">ABOUT US</p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A2F4A] mb-8 leading-tight">
              Your Local Plumbing<br />& Heating Experts
            </h1>

            <div className="space-y-6 text-gray-600 text-lg leading-relaxed">
              <p>
                Wharfedale Plumbing & Heating has been serving the local community in Otley and surrounding areas for over 15 years. We're a family-run business built on traditional values of honest service, quality workmanship, and customer care.
              </p>
              <p>
                Based right here in Otley, we understand the unique needs of local homes and businesses. Whether it's an emergency callout in the middle of the night or a planned bathroom renovation, we treat every job with the same level of professionalism and attention to detail.
              </p>
              <p>
                Our team of Gas Safe registered engineers are fully qualified and insured, staying up-to-date with the latest industry standards and technologies. We take pride in our work and in being part of the Wharfedale community.
              </p>
              <p className="text-[#1A2F4A] font-semibold">
                When you choose Wharfedale Plumbing & Heating, you're choosing local expertise, reliable service, and peace of mind.
              </p>
            </div>
          </motion.div>

          {/* Right - Image with Stats */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-2"
          >
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/1fa90de60e0331bd33c9e5287eb3948c.jpg"
                alt="Wharfedale Plumbing & Heating team"
                className="w-full h-full object-cover object-top"
              />

              {/* Stat Cards */}
              <div className="absolute bottom-6 right-6 space-y-3">
                <div className="bg-white rounded-2xl p-5 shadow-lg">
                  <div className="text-4xl font-bold text-[#1A2F4A]">15+</div>
                  <div className="text-sm text-gray-600 font-medium">Years</div>
                </div>
                <div className="bg-white rounded-2xl p-5 shadow-lg">
                  <div className="text-4xl font-bold text-[#1A2F4A]">500+</div>
                  <div className="text-sm text-gray-600 font-medium">Happy Customers</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;